import React, { useState } from 'react';
import './navbar.scss';
import { useWeb3React } from '@web3-react/core'
import useAuth from '../../../hooks/useAuth';
import twitter from '../../../Assets/social/twitter.svg'
import discord from '../../../Assets/social/discord.svg'
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { Link } from 'react-scroll';
import Banner from '../main-banner/Banner';
import Random from '../RandomNft/Random';
import Faqs from '../faqs/Faqs';
import Slider from '../../slider/Slider';

import metamask from '../../../Assets/walletImages/metamask.png'
import walletImage from '../../../Assets/walletImages/sacn-wallet.png'

const Navbar = () => {
  const [show, setshow] = useState(false);
  const { account } = useWeb3React();
  const { login, logout } = useAuth();
  const connectWallet = () => {
    setshow(true);
  }

  console.log("account", account)
  const connectMetamask = () => {
    localStorage.setItem("connectorId", "injected")
    if (account) {
      logout()
    } else {
      login("injected")
    }
    setshow(false);
  }
  const disconnectWallet = () => {
    logout();
  }
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  const Close = () => setClick(false);

  const trustWallet = async () => {
    localStorage.setItem("connectorId", "walletconnect")
    if (account) {
      logout()
    } else {
      login("walletconnect")
    }
    setshow(false);
  }


  return (
    <>
    <div className="main-banner">
      <div className={click ? "main-container" : ""} onClick={() => Close()} />
      <nav className="navbar" onClick={(e) => e.stopPropagation()}>
        <div className="nav-container">
          {/* <NavLink exact to="/" className="nav-logo">
              CodeBucks
              <i className="fa fa-code"></i>
            </NavLink> */}

          <ul className={click ? "nav-menu active" : "nav-menu"}>
            {/* <li className="nav-item">
              <Link
                exact
                to="/"
                activeClassName="active"
                className="nav-links white"
                onClick={click ? handleClick : null}
              >
                Home
              </Link>
            </li> */}
            <li className="nav-item">
              <Link
                exact
                to="My-Nft"
                activeClassName="active"
                className="nav-links white"
                onClick={click ? handleClick : null}
              >
                MyNft
              </Link>
            </li>
            <li className="nav-item" >
              <Link
                exact
                to="gbeaks"
                activeClassName="active"
                className="nav-links white"
                onClick={click ? handleClick : null}
              >
                Metis
              </Link>
            </li>
            <li className="nav-item">
              <Link
                exact
                to="faqs"
                activeClassName="active"
                className="nav-links white"
                onClick={click ? handleClick : null}
              >
              FAQ
              </Link>
            </li>
            <li className="mt6"><a href="https://twitter.com/FinanceJft" target="_blank" rel="noreferrer" className="social_link"><img src={twitter} alt=""/> </a></li>
            <li className="mt6"><a href="https://discord.com/invite/2Ek5X2wtth" target="_blank" rel="noreferrer" className="social_link"><img src={discord} alt="" /> </a></li>
            {/* <li className="mt6"><a className="social_link"><img src={opensea} /> </a></li> */}
            {account ? 
            <button className="btn_connect" type="button" onClick={disconnectWallet} >Disconnect</button> 
            : <button className="btn_connect" type="button" onClick={connectWallet}>Connect Wallet</button>}
              <p className="white margin_address">
                {account === undefined
                  ? ""
                  : account === null
                    ? "None"
                    : `${account.substring(0, 6)}...${account.substring(
                      account.length - 4
                    )}`}
              </p>
              {/* <div className="golduck">
                <a href="https://golduck.org/" target="_blank" >GOLDUCK</a>
              </div> */}
              {/* <li>
              <a>Gold Luck
              </a></li> */}
          </ul>
          <div className="nav-icon" onClick={handleClick}>
            <i className={click ? "fa fa-times" : "fa fa-bars"}></i>
          </div>

        </div>

      </nav>
      <Modal isOpen={show} className="register-modal connect-modal" size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <ModalHeader >
          <button type="button" className="close" data-dismiss="modal" onClick={() => setshow(false)} aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </ModalHeader>
        <ModalBody className="modal-body">
          <div className="container main-divs">
            <h1 className="modal_heading">Select Wallet Provider</h1>
            <div className="metamask_main">
            <button onClick={connectMetamask} type="button" className="metamask_btn">
              <div className="meta-mask" >
                <img src={metamask} alt="" />
              </div>
            </button>
            </div>
              <div className="wallets_main">
            <button onClick={trustWallet} type="button" className="metamask_btn">
              <div className="scan-wallet" >
                <img src={walletImage} alt="" />
                <h1 className="modal_heading">WalletConnect</h1>
              </div>
            </button>
            </div>
            <p className="main-term">By connecting, I accept Jupiter Metis'   <Link className="link-scan" href="#">Terms of Service</Link></p>
          </div>
        </ModalBody>
      </Modal>

      <section >
        <Banner/>
        </section>
      </div>
        {/* <section id="about">
         <About/>
        </section> */}
        <section id="My-Nft">
          <Random/>
        </section>
      <section id="gbeaks">
      <Slider/>
        </section>
        {/* <section id="category">
      <Tab/>
        </section> */}
        <section id="faqs">
      <Faqs/>
        </section>
    </>
  )
}

export default Navbar;
